import React from 'react';
import * as styles from './section-title.module.css';

const SectionTitle = ({ children }) => {
  return (
    <h2 className={styles.title}>
      {children}
    </h2>
  );
};

export default SectionTitle;
